import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="nosotros" className="py-24 bg-navy relative overflow-hidden" data-id="element-11">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-jml-blue/5 blur-[150px] rounded-full pointer-events-none" data-id="element-12" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-15">
            <h2 className="text-sm font-bold tracking-widest text-jml-orange uppercase mb-3" data-id="element-16">
              Quiénes Somos
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-white mb-8 font-heading leading-tight" data-id="element-17">
              Especialistas en{' '}
              <span className="text-jml-blue" data-id="element-18">obras y mantenimiento</span>
            </h3>

            <div className="space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-19">
              <p data-id="element-20">
                <strong className="text-white font-semibold" data-id="element-21">
                  JML Ingeniería y Mantención Industrial
                </strong>{' '}
                es una empresa especializada en obras civiles, mantenimiento
                industrial y ejecución de proyectos para empresas.
              </p>
              <p data-id="element-22">
                Acompañamos a nuestros clientes desde la planificación hasta la
                ejecución, asegurando cumplimiento de plazos, continuidad
                operativa y altos estándares técnicos en cada trabajo.
              </p>
              <p data-id="element-23">
                Trabajamos con empresas del sector industrial, alimentario y
                retail, así como en proyectos bajo licitación pública,
                adaptándonos a entornos exigentes y requerimientos específicos.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="relative" data-id="element-24">
            <div className="grid grid-cols-2 gap-3" data-id="element-25">
              <div className="rounded-xl overflow-hidden shadow-lg shadow-black/30 aspect-square group" data-id="element-26">
                <img src="https://cdn.magicpatterns.com/uploads/cn3zcnnyWULLXkLiJ656Sd/WhatsApp_Image_2026-04-11_at_21.30.52_(3).jpg" alt="Equipo JML trabajando en instalación industrial" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-27" />
              </div>
              <div className="rounded-xl overflow-hidden shadow-lg shadow-black/30 aspect-square group" data-id="element-28">
                <img src="https://cdn.magicpatterns.com/uploads/hNhUSnGvyWUyfk2bTfyzE4/WhatsApp_Image_2026-04-11_at_21.30.52_(2).jpg" alt="Equipo JML en obra civil con armadura de fierro" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-29" />
              </div>
              <div className="rounded-xl overflow-hidden shadow-lg shadow-black/30 aspect-square group" data-id="element-30">
                <img src="https://cdn.magicpatterns.com/uploads/tzKaddpG798QyzHNioYSxT/WhatsApp_Image_2026-04-11_at_21.30.52_(1).jpg" alt="Montaje de estructura metálica con plataformas elevadoras" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-31" />
              </div>
              <div className="rounded-xl overflow-hidden shadow-lg shadow-black/30 aspect-square group" data-id="element-32">
                <img src="https://cdn.magicpatterns.com/uploads/4Au3qVDXgSSmEZgzMRaugn/WhatsApp_Image_2026-04-11_at_21.30.52.jpg" alt="Trabajador JML supervisando estructura metálica" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-33" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}